<template>
  <div class="program-card" @click="handleClick" :style="{ cursor: clickable ? 'pointer' : 'default' }">
    <h4>{{ icon }} {{ title }}</h4>
    <p>{{ description }}</p>
    <p v-if="clickable" style="margin-top: 1rem;"><strong>Click to view {{ actionText }} →</strong></p>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable no-undef */
interface Props {
  icon?: string
  title: string
  description: string
  clickable?: boolean
  actionText?: string
}

const props = withDefaults(defineProps<Props>(), {
  icon: '',
  clickable: true,
  actionText: 'details'
})

const emit = defineEmits<{
  click: []
}>()
/* eslint-enable no-undef */

const handleClick = () => {
  if (props.clickable) {
    emit('click')
  }
}
</script>

<style scoped>
.program-card {
  background: var(--white, #ffffff);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.program-card:hover {
  transform: translateY(-5px);
}

.program-card h4 {
  color: var(--primary-color, #2c4a6b);
  margin-bottom: 1rem;
  margin-top: 0;
  font-family: 'Poppins', sans-serif;
}

.program-card p {
  color: var(--text-light, #666666);
  line-height: 1.6;
}
</style>
